module.exports = __webpack_public_path__ + "img/header-bar.4865f42c.png";